import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequestService } from './http-request.service';

@Injectable({
  providedIn: 'root'
})
export class KnowledgebaseSettingService {

  private stateUrl = 'api/v1/admin/ai-settings';


  constructor(private httpRequest: HttpRequestService) {
  }

  addAiSetting(formData: FormData): Observable<Response> {
    return this.httpRequest.filePost(this.stateUrl, formData);
  }

  getAiSettingById(id: string): Observable<Response> {
    const myUrl = this.stateUrl + '/' + id
    return this.httpRequest.get(myUrl);
  }


  aiSettingUpdate(id: string,formData: FormData): Observable<Response[]> {
    const myUrl = this.stateUrl + '/' + id
    return this.httpRequest.put(myUrl, formData);
  }
  aiSettingList(): Observable<Response> {
    return this.httpRequest.get(this.stateUrl);
  }

  deleteById(id: String): Observable<Response> {
    return this.httpRequest.delete(this.stateUrl + '/' + id)
  }
}
